import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import TimeSlots from '../../../Shared/TimeSlots/TimeSlots';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import Config from '../../../../Config';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import { goToPage, setPercent, setTechnicianSelectedDay, setTechnicianSelectedTime, getTechnicianTimeSlots, report, GetPriceAndTechnicianType, pinTechnicianAfterSlot } from '../MovingBlockSlice';


const TechnicianPage = (props) => {
  const discount = props.movingDiscounts?.find(({ offerType }) => offerType.value === 1);
  const title = props.timeSlotNotAvailable ? 'מצטערים, זמן הגעת הטכנאי שבחרת כבר לא פנוי' : ('נוכל להיות אצלך ביום ' + props.timeSlotTitle);
  const btnText = props.pinTechnicianDetails?.isTechnician ? 'אישור ותיאום' : 'המשך';

  useEffect(() => {
    props.setPercent(70);
    if (props.timeSlotNotAvailable) {
      gtag4({
        event: 'Moving_Step5_RescheduleTechMeetingPage_S4',
        title: title,
        step: '5',
        action: 'RescheduleTechMeetingPage_S4',
        funnel_name: '1 - MovingWithProducts',
      });
    }
    if (props.pinTechnicianDetails?.isTechnician) {
      gtag4({
        event: 'Moving_Step3_TechMeetingPinPage',
        title: title,
        step: '3',
        action: 'TechMeetingPinPage',
        funnel_name: '1 - MovingWithProducts',
      });
    }
    else {
      gtag4({
        event: 'Moving_Step3_TechMeetingPage',
        title: title,
        step: '3',
        action: 'TechMeetingPage',
        funnel_name: '1 - MovingWithProducts',
      });
    }
    props.getTechnicianTimeSlots();
  }, []);

  useEffect(() => {
    if (props.timeSlotTitle) {
      props.report({ actionType: "Technician Date", status: "Ongoing", messageText: "Technician Date Page Displayed", products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param5: props.timeSlotTitle, param9: props.technicianType, param10: props.pinTechnicianDetails?.technicianParams?.addDays ?? '2' })
    }
  }, [props.timeSlotTitle]);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      {props.pinTechnicianDetails?.isTechnician && <h1 className='moving-title-big'>שלב אחרון וסיימנו</h1>}
      <h1 className='moving-title-big'>{title}</h1>
      <h2 className='moving-title-small'>אם זה לא מתאים, אפשר לבחור יום ושעה אחרים</h2>
      {discount?.isDisplayOffer?.value &&
        <>
          <div className='moving-title-small-container'>
            <span><Image src={Config.epiBaseUrl + discount.iconImage.value?.url} /></span>
            <h3 className='moving-title-small-purple like-icon'>{discount.offerText?.value}</h3>

          </div>
        </>
      }
    </div>
  );

  function handleSelectDay(day) {
    props.setTechnicianSelectedDay(day);
  }

  function handleSelectHours(hour) {
    props.setTechnicianSelectedTime(hour);
  }

  function handleBtnClick() {
    if (props.timeSlotNotAvailable) {
      gtag4({
        event: 'Moving_Step5_RescheduleTechMeetingButton_S4',
        title: title,
        step: '5',
        action: 'RescheduleTechMeetingButton_S4',
        funnel_name: '1 - MovingWithProducts',
      });
      props.report({ actionType: 'Technician Busy New Date', status: 'Ongoing', messageText: 'Technician Date Button Clicked', products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param5: props.fullDate, param10: props.pinTechnicianDetails?.technicianParams?.addDays ?? '2' })
    }
    if (props.pinTechnicianDetails?.isTechnician) {
      gtag4({
        event: 'Moving_Step3_TechMeetingPinContinueButton',
        title: title,
        button: 'המשך',
        step: '3',
        action: 'TechMeetingPinContinueButton',
        funnel_name: '1 - MovingWithProducts',
      });
      props.pinTechnicianAfterSlot();
    }
    else {
      gtag4({
        event: 'Moving_Step3_TechMeetingContinueButton',
        title: title,
        button: 'המשך',
        step: '3',
        action: 'TechMeetingContinueButton',
        funnel_name: '1 - MovingWithProducts',
      });
      props.report({ actionType: "Technician Date", status: "Ongoing", messageText: "Technician Date Page Button Clicked", products: props.products, param2: props.fullAddress, selectedProducts: props.selectedProducts, param4: props.selectedEntry?.infrastructure, param5: props.fullDate, param9: props.technicianType, param10: props.pinTechnicianDetails?.technicianParams?.addDays ?? '2' })
      props.goToPage("summaryPage");
    }
  }

  return (
    <>
      <ProgressLine percent={props.percent} />
      {currentPageHeadline}
      <TimeSlots technicianTimes={props.timeSlots} onSelectDay={handleSelectDay} onSelectHours={handleSelectHours} />
      <MovingFooter
        onBtnClick={handleBtnClick}
        btnText={btnText}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    timeSlots: state.movingBlock.movingApartmentData.technicianData.timeSlots,
    timeSlotTitle: state.movingBlock.movingApartmentData.technicianData.timeSlotTitle,
    fullDate: state.movingBlock.movingApartmentData.technicianData.selectedTechnicianTimeSlot.fullDate,
    selectedTechnicianTimeSlot: state.movingBlock.movingApartmentData.technicianData.selectedTechnicianTimeSlot,
    products: state.movingBlock.movingApartmentData.products,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedEntry: state.movingBlock.movingApartmentData.address.selectedEntry,
    fullAddress: state.movingBlock.movingApartmentData.address.fullAddress,
    movingDiscounts: state.movingBlock.movingEpiData.movingDiscounts?.expandedValue,
    timeSlotNotAvailable: state.movingBlock.movingApartmentData.timeSlotNotAvailable,
    pinTechnicianDetails: state.movingBlock.movingApartmentData.pinTechnicianDetails,
    technicianType: state.movingBlock.movingApartmentData.technicianType
  };
};

const mapDispatchToProps = { goToPage, setPercent, setTechnicianSelectedDay, setTechnicianSelectedTime, getTechnicianTimeSlots, report, GetPriceAndTechnicianType, pinTechnicianAfterSlot };

export default connect(mapStateToProps, mapDispatchToProps)(TechnicianPage);
